import { render, staticRenderFns } from "./HowtoManageBroadcastEmails.vue?vue&type=template&id=45793079&"
import script from "./HowtoManageBroadcastEmails.vue?vue&type=script&lang=js&"
export * from "./HowtoManageBroadcastEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports